import { createLoadBalancingAtoms } from "@afar-research/client-runtime/state/load-balancing";

import { connectionAtomRuntime } from "./runtime";

export const loadBalancing = createLoadBalancingAtoms(connectionAtomRuntime);
